import { http, httpFile } from './http_service';

//Get all
export function all(dealerId){
    return http().get(`/dashboard-dealer/all/${dealerId}`);
}
export function thisMonth(dealerId){
    return http().get(`dashboard-dealer/this-month/${dealerId}`);
}

export function lastMonth(dealerId){
    return http().get(`dashboard-dealer/last-month/${dealerId}`);
}

export function thisYear(dealerId){
    return http().get(`/dashboard-dealer/this-year/${dealerId}`);
}

export function lastYear(dealerUserId){
    return http().get(`/dashboard-dealer/last-year/${dealerUserId}`);
}

